import myUtils from "@/util/myUtils";
/**
 * 隐藏手机号码
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
const  yesNo = function (value) {
  if (value=="Y") return '是';
  else if (value=="N") return '否';
}

/**
 * 性别
 * @param val {Number} 性别
 * @return {String}
 */
const  sexName = function (value) {
  let sex = "--";
  switch (value) {
    case 1:
      sex = "男"
      break
    case 2:
      sex = "女"
      break
  }
  return sex;
}

/**
 * 祝福类型
 * @param val {Number} 祝福类型
 * @return {String}
 */
 const  giftType = function (value) {
  let type = "--";
  switch (value) {
    case 0:
      type = "生日贺卡"
      break
    case 1:
      type = "入职周年贺卡"
      break
  }
  return type;
}

/**
 * YN转换是否
 * @param val {Number, String} 转换的字符串对象
 * @param retain {Number} 保留位数
 * @return {String}
 */
const  txtEmpty = function (value) {
  if(typeof(value)=="number" && value==0) return value;
  if (value==null||value==undefined||value==="") return '--';
  return value;
}

/**
 * 转化数字,保留两位小数
 * @param val {Number, String} 转换的数字
 * @return {Number}
 */
const  toFixed2 = function (value) {
  if (value !== "" && value !== null && value !== undefined) {
    return new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2 ,maximumFractionDigits: 2}).format(value).replace(/,/g, "");
  }
  return value
}

/**
 * 转化数字,保留四位小数
 * @param val {Number, String} 转换的数字
 * @return {Number}
 */
const  toFixed4 = function (value) {
  if (value !== "" && value !== null && value !== undefined) {
    return new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 4 ,maximumFractionDigits: 4}).format(value).replace(/,/g, "");
  }
  return value
}

/**
 *
 * @param {*} value 需要转化的值
 * @param {*} type
 * @returns
 */
const  toFixedDrugPrice = function (value, type=false) {
  if (value === "" || value === null || value === undefined) {
    return "--";
  }
  if (type) {
    return new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 4 ,maximumFractionDigits: 4}).format(value).replace(/,/g, "");
  }
  return new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2 ,maximumFractionDigits: 2}).format(value).replace(/,/g, "");
}

/**
 *
 * @param {*} value 需要转化的值
 * @param {*} type
 * @returns
 */
const  toFixedDrugNum = function (value, type=false) {
  if (value === "" || value === null || value === undefined) {
    return "--";
  }
  if (type) {
    return new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2 ,maximumFractionDigits: 2}).format(value).replace(/,/g, "");
  }
  return value
}

/**
 *
 * @param {*} value 需要转化的值
 * @param {*} type
 * @returns
 */
const  toFixedDrugPrice2 = function (value) {
  if (value === "" || value === null || value === undefined) {
    return "--";
  }
  value = Number.isNaN(parseFloat(value)) ? 0 : parseFloat(value);
  let res = 0;
  if(value <= 0.01 && value > 0) res = 0.01;
  if(value > 0.01) res = myUtils.math.divide(Math.floor(myUtils.math.multiply(value,100)),100);
  if(value <= 0) res = 0;
  return new Intl.NumberFormat('zh-CN', { minimumFractionDigits: 2 ,maximumFractionDigits: 2}).format(res).replace(/,/g, "");
}

export {
  txtEmpty,
  toFixed2,
  toFixed4,
  toFixedDrugPrice,
  toFixedDrugPrice2,
  toFixedDrugNum,
  yesNo,
  sexName,
  giftType
}



// WEBPACK FOOTER //
// ./src/filters/index.js